import { z } from 'zod';
import type { UnitDef } from '../sim/data/types';
import { parseOrThrow } from './validate';

const UnitFile = z.object({
  id: z.string().min(1),
  role: z.enum(['worker', 'melee', 'ranged', 'cavalry', 'caster', 'siege']),
  speed: z.number().int().positive(),
  cost: z.object({ gold: z.number().int().nonnegative(), lumber: z.number().int().nonnegative() }),
  trainTicks: z.number().int().positive(),
  supply: z.number().int().nonnegative(),
  hp: z.number().int().positive(),
  builds: z.array(z.string().min(1)).default([]),
  combat: z
    .object({
      damage: z.number().int().positive(),
      range: z.number().int().positive(),
      cooldownTicks: z.number().int().positive(),
      acquireRange: z.number().int().nonnegative(),
    })
    .optional(),
  gather: z
    .object({
      carry: z.number().int().positive(),
      miningTicks: z.number().int().positive(),
      choppingTicks: z.number().int().positive(),
    })
    .optional(),
});

export type UnitFile = z.infer<typeof UnitFile>;

export function parseUnitDef(
  raw: unknown,
  source = 'unit file',
): UnitDef & { role: UnitFile['role'] } {
  const f = parseOrThrow(UnitFile, raw, source);
  return {
    id: f.id,
    role: f.role,
    speed: f.speed,
    cost: f.cost,
    trainTicks: f.trainTicks,
    supply: f.supply,
    hp: f.hp,
    builds: f.builds,
    gather: f.gather,
    combat: f.combat,
  };
}
